import {Component, OnInit, NgZone} from '@angular/core';
import {SessionService} from "../../core/session.service";
import {AgeRangeService} from "./age-range.service";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {ActivatedRoute} from "@angular/router";
import {ModalService} from "../../root/modal/modal.service";
import {NotificationService} from "../../root/toast/notification.service";
import {GAService} from "../../root/ga/ga.service";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {AgeRangeValidatorService} from "./age-range-validator.service";

@Component({
    selector: 'age-range',
    templateUrl: './age-range.component.html',
    providers: [AgeRangeService, AgeRangeValidatorService]
})
export class AgeRangeComponent implements OnInit {

    constructor(private session: SessionService, private ageRangeService: AgeRangeService,
                private zone: NgZone, private loading: LoadingWheelService, private validator: AgeRangeValidatorService,
                private route: ActivatedRoute, private modalService: ModalService,
                private notification: NotificationService, private gaService: GAService, private _fb: FormBuilder) {
    }

    hasCharge:boolean;
    editableAgeRange:boolean = false;
    companyOid:number;
    ageRange:any = {};
    metadata:any = {};
    chargeType:any = {};
    endLoading:boolean=false;
    listMinAge = [{id: 21, value: '21'}, {id: 22, value: '22'}, {id: 23, value: '23'}, {id: 24, value: '24'}, {id: 25, value: '25'}];
    chargeTypesList = [{id: 'PERCENTAGE', value: 'age_ranges.type.PERCENTAGE'}, {id: 'AMOUNT', value: 'age_ranges.type.AMOUNT'}];
    listMaxAge = [{id: 22, value: '22'}, {id: 23, value: '23'}, {id: 24, value: '24'}, {id: 25, value: '25'}, {id: 26, value: '26'}, {id: 27, value: '27'}, {id: 28, value: '28'}, {id: 29, value: '29'}, {id: 30, value: '30'}];
    errors: any = {};
    errorMessages = {
        'amountAgeRange': 'warning.invalidNumberFormat',
        'chargeType': 'common.error.REQUIRED',
        'ageTo': 'common.error.REQUIRED'
    };
    ageChargeForm: any;

    ngOnInit() {
        this.hasCharge = false;
        if(!this.session.getUserSession()){
            this.session.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.bindSessionParameters();
                }
            });
        }else{
            this.bindSessionParameters();
        }

        this.zone.run(() => {
            this.load();
        });
    }
    
    load(){
        this.loadCompany();
        this.loadData();
    }
    
    loadCompany() {
        this.loading.show();

        this.route.params.subscribe(params => {
            this.companyOid = params['id'];

            this.ageRangeService.get(this.companyOid).subscribe((response) => {
                this.ageRange = response[0];
                console.log(this.ageRange);
                //Load selects options
                if(this.ageRange.minimumRentalAge < 21){
                    this.ageRange.minimumRentalAge = 21;
                }
                if(this.ageRange.value && this.ageRange.value > 0){
                    this.hasCharge = true;
                }
                this.bindValidations();
                this.endLoading = true;

            });
        });
    }

    activateCharge(event){
        this.hasCharge = !this.hasCharge;
        this.errors = {};
        this.ageRange.to = null;
        this.ageRange.value = '';
        if(this.hasCharge){
            this.getMaxAgeList(this.ageRange.minimumRentalAge);
            this.getChargeType();
        }else{
            this.listMaxAge = [];
            this.chargeTypesList = [];
        }
    }

    loadData(){
        this.loading.show();
        this.ageRangeService.loadData().subscribe((response) => {
            this.chargeType = response;
            this.endLoading = true;
            this.loading.hide();
        });
    }

    bindSessionParameters(){
        this.editableAgeRange = this.session.loggedUserAllowed('PERM_AGE_RANGE_EDIT');
        this.metadata.currencyCode = this.session.getUserSession().currencyCode;
    }

    updateMaxAgeList(event){
        if(this.hasCharge){this.getMaxAgeList(this.ageRange.minimumRentalAge)};
    }

    getMaxAgeList(from){
        from = parseInt(from);
        this.listMaxAge = [];
        if(this.ageRange && (this.ageRange.to==undefined || this.ageRange.to<=from)){this.ageRange.to=null;/*this.ageRange.to=from+1*/};
        for(let i=from+1;i<=30;i++){
            this.listMaxAge.push({id: i, value: i.toString()});
        }
    }

    validateAgeTo(event){
        if(event.target.value == "" || event.target.value == null || event.target.value == undefined){
            this.ageRange.to = null;
        }
    }

    validateChargeType(event){
        this.ageRange.value = '';
        if(event.target.value == "" || event.target.value == null || event.target.value == undefined){
            this.ageRange.chargeType = null;
        }
    }

    getChargeType(){
        this.chargeTypesList = [];
        this.chargeType.forEach((type)=>{
            this.chargeTypesList.push({id: type, value: 'age_ranges.type.'+type})
        });
    }

    updateValidation(field){
        if(this.errors != undefined && this.errors[field]){
            this.errors[field] = null;
        }
    }

    private bindValidations() {
        this.ageChargeForm = this._fb.group({
            minimumRentalAge: ['', Validators.required],
            chargeType: ['', this.validator.validateChargeType],
            ageTo: ['', this.validator.validateTo],
            amountAgeRange: ['', this.validator.validateAmountRange]
        });
    }

    private bindValues() {
        this.ageChargeForm.controls['minimumRentalAge'].setValue(this.ageRange.minimumRentalAge);
        this.ageChargeForm.controls['chargeType'].setValue({
            hasCharge: this.hasCharge,
            chargeType: this.ageRange.chargeType
        });
        this.ageChargeForm.controls['ageTo'].setValue({
            hasCharge: this.hasCharge,
            to: this.ageRange.to
        });
        this.ageChargeForm.controls['amountAgeRange'].setValue({
            hasCharge: this.hasCharge,
            chargeType: this.ageRange.chargeType,
            value: this.ageRange.value
        });
    }

    save(){
        this.errors = {};
        if(!this.hasCharge){
            this.ageRange.value = null;
            this.ageRange.chargeType = null;
            this.ageRange.to = null;
        }
        this.bindValues();
        let validations = this.validator.validate(this.ageChargeForm);
        if(validations.valid){
            if(this.ageRange.oid == null){
                this.ageRangeService.create(this.companyOid, this.ageRange).subscribe((result) => {
                    this.saveData();
                }, (err) => {
                    this.notification.notifyErrorByCode('common.confirmationMessage.ERROR_SAVE');
                })
            }else{
                this.ageRangeService.update(this.companyOid, this.ageRange, this.ageRange.oid).subscribe((result) => {
                    this.saveData();
                }, (err) => {
                    this.notification.notifyErrorByCode('common.confirmationMessage.ERROR_SAVE');
                })
            }
        }else{
            this.errors = validations.errors;
        }
    }

    saveData(){
        let labelAgeMin = this.ageRange.minimumRentalAge;
        let labelAgeCharge = !this.hasCharge ? this.ageRange.to : "NoCharge";
        this.gaService.notify("Autos_rangos_de_edad", "guardar_edad_minima", [labelAgeMin]);
        this.gaService.notify("Autos_rangos_de_edad", "guardar_recargo", [labelAgeCharge]);
        this.notification.notifyInfoByCode('age_ranges.confirmationMessage.SUCCESS');
    }

    cancel(){
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.load());
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/ageRange/age-range.component.ts